import Mustache from 'mustache';
import MicroModal from '../vendors/microModal';
import $ from "jquery";

export function mModals() {
  MicroModal.init({
    onShow: (modal, trigger, event) => {
      if(modal.hasAttribute('data-has-tabs')) {
        // Safari doesn't return the correct activeElement so we have to reach the trigger some other way.
        // `trigger` returns the <body> element on Safari
        const tabToOpen = trigger.dataset.tabsTarget;

        if ( tabToOpen ) {
          $(`#${modal.id} [data-tabs]`).foundation('selectTab', tabToOpen, false);
        }
      }

      // If opening a lodging modal..
      if(trigger.dataset.lodging) {

        // Get lodging data & template
        const lodgingData = JSON.parse(trigger.dataset.lodging.replace(/~~/g, '"').replace(/(\r\n|\n|\r)/gm, ''));
        const residencyDataTemplate = document.querySelector('#residency-location-data-template').innerHTML;
        Mustache.parse(residencyDataTemplate);

        // Insert render into section
        document.querySelectorAll('.js-residency-location-data').forEach((residencyDataSection) => {
          residencyDataSection.innerHTML = Mustache.render(residencyDataTemplate, lodgingData);
        });

        // Display current lodging plans into markup
        if ( lodgingData.plans ) {
          const lodgingPlansDataTemplate = document.querySelector('#lodging-plans-data-template').innerHTML;
          Mustache.parse(lodgingPlansDataTemplate);
          let lodgingPlans = JSON.parse(lodgingData.plans.replace(/\*/g, '"'));
          let dataRendered = '<header class="medias-downloads__title">' +
            '<span class="highlight">'+lodgingData.lodging_types+' - '+lodgingData.area+'m2</span> <span>'+lodgingData.price.toLocaleString('fr-FR')+' €</span>' +
            '</header>';
          dataRendered += '<ul class="medias-downloads__list">';
          $.each(lodgingPlans, function (key, plan) {
            dataRendered += Mustache.render(lodgingPlansDataTemplate, plan);
          });
          dataRendered += '</ul>';
          document.querySelector('.js-lodging-plans-data').innerHTML = dataRendered;
        }

        // Set Brochure hidden URL to button
        const downloadBrochureButton = document.querySelector('.js-download-brochure');
        if ( downloadBrochureButton ) {
          downloadBrochureButton.setAttribute('href', downloadBrochureButton.dataset.url);
        }

        // Set residency & lodging data into form
        if ( document.querySelector('#input_4_13') )
          document.querySelector('#input_4_13').value = lodgingData.residency_id;
        if ( document.querySelector('#input_4_14') )
          document.querySelector('#input_4_14').value = lodgingData.lodging_id;

      }

      let modalLodgingSubtitle = modal.querySelector('.js-subtitle-lodging');
      if (modalLodgingSubtitle) {
        if ( modal.id == 'modal-contact' && trigger.dataset.lodgingname ) {
          modalLodgingSubtitle.innerHTML = trigger.dataset.lodgingname;
          modalLodgingSubtitle.classList.remove('hide');
        } else {
          modalLodgingSubtitle.innerHTML = '';
          modalLodgingSubtitle.classList.add('hide');
        }
      }
    },
    disableScroll: true,
    disableFocus: true,
    debugMode: true
  });

  window.addEventListener('load', function() {

    // Display Brochure & Plans buttons after form submission
    $(document).on('gform_confirmation_loaded', function(event, formId){
      if( formId == 3 ) {
        document.querySelector('.js-medias-downloads').classList.remove('hide');
      }
      if( formId == 4 ) {
        document.querySelector('.js-lodging-plans-data').parentNode.classList.remove('hide');
      }
    });

  })
}

mModals();
